import { t } from '../i18n/idioma';
import { useFechar } from '../input/useAtalhos';
import { Gump } from './Gump';

interface Props {
  de: string;
  modo: string;
  texto?: string;
  titulo?: string;
  aceitar?: string;
  recusar?: string;
  onAccept(): void;
  onRefuse(): void;
}

export function DueloConviteGump({ de, modo, texto, titulo, aceitar, recusar, onAccept, onRefuse }: Props) {
  useFechar(onRefuse, { modal: true });
  const loot = modo === 'com_loot';
  return (
    <div className="modal" role="presentation" onClick={onRefuse}>
      <div role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
        <Gump title={titulo ?? t('duelo.menu')}>
          <div className="stack">
            <p>{texto ?? t('duelo.convite', { nome: de, modo: loot ? t('duelo.comLoot') : t('duelo.semLoot') })}</p>
            {!texto && <p className="duelo-nota">{loot ? t('duelo.comLootLinha') : t('duelo.semLootLinha')}</p>}
            <div className="row row--split">
              <button type="button" className="btn btn--ghost" onClick={onRefuse}>{recusar ?? t('comum.recusar')}</button>
              <button type="button" className="btn btn--primary" onClick={onAccept}>{aceitar ?? t('comum.aceitar')}</button>
            </div>
          </div>
        </Gump>
      </div>
    </div>
  );
}
